import React, { useContext } from 'react';
import Dashboard from './Dashboard';
import Navbar from './common/Navbar';
import { useParams } from 'react-router-dom'

import { UserContext } from './common/UserContext';
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import SessionTimeout from './SessionTimeout';

function Layout({ children }) {
  const { UM_UserCode } = useContext(UserContext);


  return (
    <div className="layout-container" >
            
      <Navbar UM_UserCode={UM_UserCode} />
      <div className="layout-content">
        <Dashboard />  <SessionTimeout />
        {/* <main className="layout-main">{<ReactGridLayout/>}</main> */}
        <main className="layout-main">{children}</main>
      </div>
    </div>
  );
}
Layout.propTypes = {
  children: PropTypes.node, // Ensures children is a valid React node
};
export default Layout;

